import Text from '@dbk/ui-text';

export const HighlightSearchText = ({ text, highlight, style, highlightStyle }) => {
  if (!highlight.trim() || typeof text !== 'string') {
    return <Text style={style}>{text}</Text>;
  }
  const regex = new RegExp(`(${highlight})`, 'gi');
  const parts = text.split(regex);
  return (
    <Text style={style}>
      {parts.filter(String).map((part, i) => {
        return regex.test(part) ? (
          <Text key={i} style={highlightStyle}>
            {part}
          </Text>
        ) : (
          part
        );
      })}
    </Text>
  );
};

